
	export default {
		props: {
			rules: Object,
			answers: {
				type: Object,
				default: () => ({})
			},
			value: {
				type: Object,
				default: () => ({})
			},
			errors: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			return {
				isDisabledC2VScore: true,
				sex: [
					{title: 'Male'},
					{title: 'Female'},
				],
				C2VScore: [],
			}
		},
		watch: {
			value: {
			    handler(newVal) {
				    const hasAnyValue = Object.values(newVal).some(val => {
				        if (val === null || val === undefined) return false;
				        if (typeof val === 'string') return val.trim() !== '';
				        if (typeof val === 'number') return true;
				        return false;
				    });

				    if (this.answers.isQuestionFourth !== hasAnyValue) {
				        this.answers.isQuestionFourth = hasAnyValue;
				    }
			    },
			    deep: true,
			    immediate: true
			}
		},
		methods: {
			isNumber(event) {
				if (event.key === '.' || event.key === ',') {
					event.preventDefault();
				}
			},
			handleSexChange(event) {
				const value = event.target.value;
				this.updateValue('sex', value);
			},
			handleEgfrChange(event) {
				const value = event.target.value;
				this.updateValue('egfr', value);

				if (value > 0 && value < 30 && this.answers.questionFirst.includes('High/Very High Risk Chronic Kidney Disease')) {
					this.rules.find(r => {
						if (r.name == 'albuminuria') {
							r.condition = true;
						}
					});
				}
			},
			updateValue(key, val) {
				let answers = this.answers;
				const updated = { ...this.value, [key]: val };

				this.$emit('input', updated);
			},
			isRuleEnabled(ruleName) {
			 	return this.rules[ruleName] === true;
			}
		}
	}
